import { render } from "./MorphToActionTargetField.vue?vue&type=template&id=4cb1d90c"
import script from "./MorphToActionTargetField.vue?vue&type=script&lang=js"
export * from "./MorphToActionTargetField.vue?vue&type=script&lang=js"

import exportComponent from "/www/yadonor/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"MorphToActionTargetField.vue"]])

export default __exports__